/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Cross-chain sync status for Crossmint integration */
export enum CrossChainStatus {
  NotSynced,
  SyncPending,
  SyncedToCrossmint,
  SyncFailed,
}

export type CrossChainStatusArgs = CrossChainStatus;

export function getCrossChainStatusEncoder(): FixedSizeEncoder<CrossChainStatusArgs> {
  return getEnumEncoder(CrossChainStatus);
}

export function getCrossChainStatusDecoder(): FixedSizeDecoder<CrossChainStatus> {
  return getEnumDecoder(CrossChainStatus);
}

export function getCrossChainStatusCodec(): FixedSizeCodec<
  CrossChainStatusArgs,
  CrossChainStatus
> {
  return combineCodec(
    getCrossChainStatusEncoder(),
    getCrossChainStatusDecoder(),
  );
}
